module.exports = __webpack_public_path__ + "static/media/processing.fef3ca79.svg";